import {ChangeDetectionStrategy, Component, inject} from '@angular/core';
import {ActivatedRoute, NavigationEnd, Router, RouterLink, RouterOutlet} from '@angular/router';
import {toSignal} from '@angular/core/rxjs-interop';
import {filter, map} from 'rxjs';
import {Tab, TabList, Tabs} from 'primeng/tabs';

@Component({
  selector: 'homey-shell',
  standalone: true,
  imports: [Tabs, TabList, Tab, RouterLink, RouterOutlet],
  templateUrl: './shell.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ShellComponent {
  protected readonly route = inject(ActivatedRoute);
  protected readonly router = inject(Router);

  // Signal of the first path segment of the current URL, used to highlight the active tab.
  protected readonly initialSegment$ = this.router.events.pipe(
    filter((event): event is NavigationEnd => event instanceof NavigationEnd),
    map((event) => event.url.split('/').filter((segment) => segment.length > 0)[0] ?? 'nyc-sync')
  );

  protected readonly initialSegment = toSignal(this.initialSegment$, {
    initialValue: 'nyc-sync',
  });
}
